import * as React from 'react';
import type { TextStoryCard } from '@org/model';
import type { StoryCardComponentProps } from './story-types';
import { pickLocalized, renderStoryMarkup, storyLangAttr, StoryCardHeading, StoryVocabRow } from './story-utils';

/** Size of the big outlined word: short numbers go huge, longer words step down to stay on one line. */
function bigSize(big: string): number {
  if (big.length > 12) return 44;
  if (big.length > 8) return 60;
  return big.length > 4 ? 84 : 132;
}

/** Text card: optional heading, a big outlined word/number, and a short text with highlighted words. */
export function StoryTextCard({ card, ctx }: StoryCardComponentProps<TextStoryCard>) {
  const body = pickLocalized(card.body, ctx.lang);
  const big = card.big?.trim() ?? '';
  return (
    <div className="zs-pg-in" data-testid="story-card-text">
      <StoryCardHeading card={card} lang={ctx.lang} />
      {big ? (
        <div className="zs-bigo" aria-hidden="true" style={{ fontSize: bigSize(big) }}>
          {big}
        </div>
      ) : null}
      <p className="zs-body" lang={storyLangAttr(body.lang)}>
        {renderStoryMarkup(body.text)}
      </p>
      <div className="zs-foot">
        <StoryVocabRow vocab={card.vocab} lang={ctx.lang} />
      </div>
    </div>
  );
}
